module.exports = __webpack_public_path__ + "img/logo.669c4da1.png";